import { CaseReducer, PayloadAction, createSlice } from '@reduxjs/toolkit';

import { get } from 'api/requests';
import { loading } from 'store/common';

import { IReducer, AppThunk } from 'store/types';
import { CallHistory, EngNetInfoProps } from 'features/EngineeringNetStatus/types';

interface EngineeringState {
  loading: boolean;
  history: CallHistory;
}

const initialState: EngineeringState = {
  loading: false,
  history: {
    statuses: [],
    id: null,
  },
};

const reset: IReducer<EngineeringState, EngineeringState> = () => initialState;

const callHistory: CaseReducer<EngineeringState, PayloadAction<CallHistory>> = (state, action) => {
  state.history = action.payload;
};

export const callHistorySlice = createSlice({
  name: 'MODAL/callHistory',
  initialState,
  reducers: {
    loading: loading as IReducer<EngineeringState, boolean>,
    callHistory,
    reset,
  },
});

const { loading: setLoading, callHistory: setCallHistory } = callHistorySlice.actions;

export const getCallHistory = (props: EngNetInfoProps): AppThunk => {
  return dispatch => {
    get<CallHistory>(
      `/api/v2/standards/engineering_networks/${Number(props.networkId)}/status-history/`,
      props,
    ).then(({ data }) => {
      dispatch(setCallHistory(data));
    });
  };
};

export { setLoading };
